// src/pages/Login.jsx
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useApp } from '../context/AppContext'
import { PasswordInput } from '../components/UI'
import LanguageSwitcher from '../components/LanguageSwitcher'

export default function Login() {
  const { login } = useApp()
  const { t } = useTranslation()
  const [email,    setEmail]    = useState('')
  const [password, setPassword] = useState('')
  const [error,    setError]    = useState('')
  const [loading,  setLoading]  = useState(false)

  const attempt = async () => {
    setError('')
    if (!email || !password) { setError(t('login.error_empty')); return }
    setLoading(true)
    const { error: err } = await login(email.trim().toLowerCase(), password)
    setLoading(false)
    if (err) { setError(t('login.error_invalid')); setPassword('') }
  }

  return (
    <div className="login-page">
      <div className="login-box">
        {/* Language switcher */}
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
          <LanguageSwitcher variant="login" />
        </div>

        {/* Logo */}
        <div className="login-logo">
          <div className="logo-icon"><i className="ti ti-wallet" aria-hidden="true" /></div>
          <div>
            <div className="logo-name">{t('app.name')}</div>
            <div className="logo-sub">{t('app.tagline')}</div>
          </div>
        </div>

        <div className="login-title">{t('login.welcome')}</div>
        <div className="login-sub">{t('login.subtitle')}</div>

        {error && (
          <div className="login-err">
            <i className="ti ti-alert-circle" aria-hidden="true" />{error}
          </div>
        )}

        <div className="login-field">
          <label htmlFor="li-email">{t('login.email')}</label>
          <input id="li-email" className="input" type="email" value={email}
            onChange={e => setEmail(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && attempt()}
            placeholder={t('login.email_placeholder')}
            autoComplete="email" autoFocus />
        </div>

        <div className="login-field">
          <label htmlFor="li-pass">{t('login.password')}</label>
          <PasswordInput id="li-pass" value={password} onChange={setPassword}
            placeholder={t('login.password_placeholder')}
            onKeyDown={e => e.key === 'Enter' && attempt()} />
        </div>

        <button className="login-btn" onClick={attempt} disabled={loading}>
          {loading
            ? <><i className="ti ti-loader-2" aria-hidden="true" style={{ animation: 'spin 1s linear infinite' }} /> {t('login.signing_in')}</>
            : <><i className="ti ti-login" aria-hidden="true" /> {t('login.sign_in')}</>
          }
        </button>

        <p style={{ textAlign: 'center', fontSize: 13, color: 'var(--gray-600)', marginTop: 18 }}>
          {t('login.no_account')}{' '}
          <Link to="/signup" style={{ color: 'var(--brand-600)', fontWeight: 600, textDecoration: 'none' }}>
            {t('login.sign_up_link')}
          </Link>
        </p>
      </div>

      <div style={{ marginTop: 16, textAlign: 'center' }}>
        <p style={{ fontSize: 12, color: 'var(--gray-600)', marginBottom: 6 }}>
          TecFin v2.0 &nbsp;·&nbsp; kempu — Key Expenses &amp; Money Planning for U &nbsp;·&nbsp;
          <a href="mailto:tecfin@kempu.in" style={{ color: 'var(--brand-600)', fontWeight: 600 }}>tecfin@kempu.in</a>
        </p>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 14, flexWrap: 'wrap' }}>
          <Link to="/legal#disclaimer" style={{ fontSize: 11, color: 'var(--gray-500)', textDecoration: 'none' }}>{t('footer.disclaimer')}</Link>
          <Link to="/legal#privacy"    style={{ fontSize: 11, color: 'var(--gray-500)', textDecoration: 'none' }}>{t('footer.privacy')}</Link>
          <Link to="/legal#terms"      style={{ fontSize: 11, color: 'var(--gray-500)', textDecoration: 'none' }}>{t('footer.terms')}</Link>
        </div>
<p style={{ marginTop: 12, fontSize: 12, color: 'var(--gray-600)', textAlign: 'center', padding: '10px 14px', background: 'var(--surface-alt)', borderRadius: 8, border: '1px solid var(--border)' }}>
  🌍 International clients: contact{' '}
  <a href="mailto:solutions@tecnize.in" style={{ color: 'var(--brand-600)', fontWeight: 600 }}>
    solutions@tecnize.in
  </a>
  {' '}for invoicing in USD / AED / SGD via bank transfer.
</p>
      </div>

      <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
    </div>
  )
}
